import React from 'react';
import { withStyles, Card, CardContent, CardHeader, CardActions,Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import cx from 'classnames';

import regularCardStyle from '../assets/regularCardStyle';

function RegularCard({ ...props }) {
  const { classes, headerColor, plainCard, cardTitle,  content, type} = props;
  const plainCardClasses = cx({
    [' ' + classes.cardPlain]: plainCard,
  });
  const cardPlainHeaderClasses = cx({
    [' ' + classes.cardPlainHeader]: plainCard,
  });
  return (

    <Card className={classes.regularCard + plainCardClasses}>
      <CardHeader
        classes={{
          root:
            classes.cardHeader + ' ' + classes[headerColor + 'CardHeader'] + cardPlainHeaderClasses,
          title: classes.cardTitle,
          subheader: classes.cardSubtitle,
        }}
        title={cardTitle}
      />
      <CardContent className={type === 'orders' ? classes.tableCardContent : classes.cardContent}>{content}</CardContent>
      {type === 'orders' ? (
        <CardActions className={classes.cardActions}>   <Button variant="contained" color="primary" className={classes.button}>
        <Link style={{ textDecoration: 'none', color:'white' }} to={`/orders/?shippingTime=late,today`}>Show All</Link>
      </Button></CardActions>
      ) : null}

      {type === 'products' ? (
        <CardActions className={classes.cardActions}>   <Button variant="contained" color="primary" className={classes.button}>
        <Link style={{ textDecoration: 'none', color:'white' }} to={`/products`}>Show All</Link>
      </Button></CardActions>
      ) : null}
    </Card>
  );
}

RegularCard.defaultProps = {
  headerColor: 'purple',
};

RegularCard.propTypes = {
  plainCard: PropTypes.bool,
  classes: PropTypes.object.isRequired,
  headerColor: PropTypes.oneOf(['orange', 'green', 'red', 'blue', 'purple', 'gray']),
  cardTitle: PropTypes.node,
  cardSubtitle: PropTypes.node,
  content: PropTypes.node.node,
};

export default withStyles(regularCardStyle)(RegularCard);



// WEBPACK FOOTER //
// ./src/components/RegularCard.jsx